module.exports = __webpack_public_path__ + "static/husayn-6f981dc86b53f82924243742bae95548.jpg";